import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { Department } from "@/model/Department";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import DepartmentValidation from "./S081500-DepartmentValidation.js";
import Paginate from "vuejs-paginate";
var DepartmentValidationObj = new DepartmentValidation();
export default {
    name: "Department",
    mounted() {
        DepartmentValidationObj.DepartmentValidation();
        this.assignRights();
        this.getAllDepartment();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_Department,
        dictEnum: dictEnum,
        Department: new Department(),
        isEditMode: false,
        DepartmentList: [],
        selectAllDepartment: false,
        tempDepartmentModel: new Department(),
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllDepartment() {
            var self = this;
            var obj = {}
            const response = await StaffEmploymentService.getAllDepartment(obj);
            if (response.data.IsSuccess) {
                self.DepartmentList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllDepartmentRecord: function () {
            var self = this;
            var IsSelected = self.selectAllDepartment;
            self.DepartmentList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleDepartmentPopup: function () {
            var arrayList = [];
            var self = this;
            self.DepartmentList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteDepartmentListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleDepartment() {
            var arrayList = [];
            var self = this;
            $('#deleteDepartmentListModel').modal('hide');
            self.DepartmentList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                departmentList: arrayList,
            };
            const response = await StaffEmploymentService.deleteDepartments(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetDepartment();
                await self.getAllDepartment();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnDepartmentSelect: function (model) {
            this.tempDepartmentModel = model;
        },
        addDepartment: function () {
            var self = this;
            $('#DepartmentModel').modal('show');
            self.isEditMode = false;
            self.Department = new Department();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveDepartmentDetail(obj) {
            var self = this;
            const response = await StaffEmploymentService.addDepartment(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetDepartment();
                await self.getAllDepartment();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editDepartment(obj) {
            var self = this;
            const response = await StaffEmploymentService.updateDepartment(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetDepartment();
                self.init();
                await self.getAllDepartment();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveDepartment() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#DepartmentModel').modal('hide');
                    const obj = {
                        model: {
                            Dept: self.Department.Dept,
                            CDesc: self.Department.CDesc,
                            EDesc: self.Department.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editDepartment(obj);
                    }
                    else {
                        self.saveDepartmentDetail(obj);
                    }
                }
            });
        },
        async editDepartmentDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempDepartmentModel.Dept != "") {
                self.Department = this.tempDepartmentModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#DepartmentModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetDepartment: function () {
            var self = this;
            self.selectAllDepartment = false;
            self.isEditMode = false;
            self.Department = new Department();
            self.tempDepartmentModel = new Department();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closeDepartmentPopup: function () {
            var self = this;
            self.selectAllDepartment = false;
            self.isEditMode = false;
            self.Department = new Department();
            self.tempDepartmentModel = new Department();
            self.$validator.reset();
            self.vErrors.clear();
            $('#DepartmentModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081500-Department/S081500-Department.js